// extracted by mini-css-extract-plugin
export var link = "_ua-0";